export const SERVICE_TYPE_PRODUCT = 'SERVICE';
export const PRODUCT_TYPE_FOOD = 'FOOD';
export const PRODUCT_TYPE_NON_FOOD = 'NON_FOOD';
export const MAF_CHECKOUT_REFERRER_URI = 'mafCheckoutReferrerUri';
export const COUNTRY_CODE_KEY = 'countryCode';
